import CommonCreate from "@/components/common/Create"
import React from "react";
import { expenseAndService } from "@/utils/objects";
import IncomingForm from "../forms/IncomingForm";
import { mergeDateAndTime } from "@/utils/formChange";

const IncomingsCreate = () => {
  const [formProp, setFormProp] = React.useState({
    ...expenseAndService,
    value: '',
    incomings_type_id: '',
  });
  
  return (
    <CommonCreate title="Create Income" resource="incomings" data={{...formProp, date: mergeDateAndTime(formProp.date, formProp.time), 
    incomings_type_id: +formProp.incomings_type_id, vehicle_id: +formProp.vehicle_id, value: +formProp.value}}>
      <IncomingForm formProp={formProp} setFormProp={setFormProp} />
    </CommonCreate>
  )
}

export default IncomingsCreate;